import UserPage from "./UserPage";

const SignInConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  auth: ["canReadUsers"],
  routes: [
    {
      path: "hr/users",
      element: <UserPage />,
    },
  ],
};

export default SignInConfig;
